import { formatDate, renderPill } from "../model/alertManagementConstants";
import { DetailMetaCard, DetailMetaLabel, DetailMetaValue, DetailTopCol, DetailTopRow } from "./detail.styles";

export const AlertManagementDetailHeader = ({ record, pillMap, detailData }) => (
  <DetailTopRow gutter={[12, 12]}>
    <DetailTopCol xs={24} sm={12} md={12} lg={12} xl={6} xxl={6}>
      <DetailMetaCard bordered={false}>
        <DetailMetaLabel>Estado de solicitud</DetailMetaLabel>
        <div>{renderPill(record?.gestionAlerta, record?.gestionAlertaCodigo, pillMap)}</div>
      </DetailMetaCard>
    </DetailTopCol>
    <DetailTopCol xs={24} sm={12} md={12} lg={12} xl={6} xxl={6}>
      <DetailMetaCard bordered={false}>
        <DetailMetaLabel>Usuario origen</DetailMetaLabel>
        <DetailMetaValue>
          {detailData?.usuarioOrigen || record?.rolRevisor || "Implementación"}
        </DetailMetaValue>
      </DetailMetaCard>
    </DetailTopCol>
    <DetailTopCol xs={24} sm={12} md={12} lg={12} xl={6} xxl={6}>
      <DetailMetaCard bordered={false}>
        <DetailMetaLabel>Fecha implementación</DetailMetaLabel>
        <DetailMetaValue>{formatDate(detailData?.fechaImplementacion || record?.fechaRegistro)}</DetailMetaValue>
      </DetailMetaCard>
    </DetailTopCol>
    <DetailTopCol xs={24} sm={12} md={12} lg={12} xl={6} xxl={6}>
      <DetailMetaCard bordered={false}>
        <DetailMetaLabel>Jornada</DetailMetaLabel>
        <DetailMetaValue>{detailData?.jornada?.nombre || record?.jornada || "—"}</DetailMetaValue>
      </DetailMetaCard>
    </DetailTopCol>
  </DetailTopRow>
);